(() => {
  'use strict';

  const ZOHO_FORM_URL =
    'https://forms.zohopublic.eu/web10/form/SaveYourBasket/formperma/IWJ-vuzBjz31V5flglkL3DemaeGDYpOhK8I8SR8bl1Q';

  const selectors = {
    root: '[data-save-cart-drawer]',
    open: '[data-save-cart-drawer-open]',
    close: '[data-save-cart-drawer-close]',
    modal: '[data-save-cart-drawer-modal]',
    iframe: '[data-save-cart-drawer-iframe]',
    loading: '[data-save-cart-drawer-loading]',
    error: '[data-save-cart-drawer-error]'
  };

  function formatMoney(amountInMinorUnits, currency = 'GBP') {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency
    }).format(amountInMinorUnits / 100);
  }

  function getShopRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  async function getCart() {
    const response = await fetch(`${getShopRoot()}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }

    return response.json();
  }



function buildCartLink(cart) {
  if (!Array.isArray(cart.items) || cart.items.length === 0) {
    throw new Error('Cart is empty.');
  }

  const cartItems = cart.items.map((item) => {
    const variantId = Number(item.variant_id);
    const quantity = Number(item.quantity);

    if (
      !Number.isSafeInteger(variantId) ||
      variantId <= 0 ||
      !Number.isInteger(quantity) ||
      quantity <= 0
    ) {
      throw new Error('The cart contains an invalid item.');
    }

    return `${variantId}:${quantity}`;
  });

  const SHOP_DOMAIN = 'yo-yodesk.co.uk';

  return `${SHOP_DOMAIN}/cart/${cartItems.join(',')}?utm_source=saved_cart&utm_medium=email&utm_campaign=save_cart`;
}
  


  function buildCartSummary(cart) {
    return cart.items
      .map((item) => {
        const productName = item.product_title || item.title || 'Product';
        const variantName =
          item.variant_title && item.variant_title !== 'Default Title'
            ? ` – ${item.variant_title}`
            : '';

        return `${item.quantity} × ${productName}${variantName}`;
      })
      .join('\n');
  }

  function buildZohoFormUrl(cart) {
    const url = new URL(ZOHO_FORM_URL);

    url.searchParams.set('cart_link', buildCartLink(cart));
    url.searchParams.set('cart_summary', buildCartSummary(cart));
    url.searchParams.set(
      'cart_total',
      formatMoney(cart.total_price, cart.currency || 'GBP')
    );
    url.searchParams.set('cart_currency', cart.currency || 'GBP');
    url.searchParams.set('cart_count', String(cart.item_count || 0));
    url.searchParams.set('cart_token', cart.token || '');
    url.searchParams.set('page_url', window.location.href);
    url.searchParams.set('saved_at', new Date().toISOString());
    url.searchParams.set('source', 'Shopify Save Cart');

    return url.toString();
  }

  function openModal(root) {
    const modal = root.querySelector(selectors.modal);

    modal.hidden = false;
    document.body.classList.add('yy-save-cart-open');

    const closeButton = modal.querySelector(selectors.close);
    closeButton?.focus();
  }

  function closeModal(root) {
    const modal = root.querySelector(selectors.modal);
    const iframe = root.querySelector(selectors.iframe);
    const openButton = root.querySelector(selectors.open);

    modal.hidden = true;
    iframe.hidden = true;
    iframe.removeAttribute('src');

    document.body.classList.remove('yy-save-cart-open');
    openButton?.focus();
  }

  
async function prepareForm(root) {
  const iframe = root.querySelector(selectors.iframe);
  const loading = root.querySelector(selectors.loading);
  const error = root.querySelector(selectors.error);

  if (!iframe || !loading || !error) {
    console.error('Save Cart: required modal elements were not found.');
    return;
  }

  loading.hidden = false;
  error.hidden = true;
  iframe.hidden = true;
  iframe.removeAttribute('src');

  try {
    console.log('Save Cart: requesting current cart…');

    const cart = await getCart();

    console.log('Save Cart: cart received:', cart);

    if (!cart.items || cart.items.length === 0) {
      throw new Error('The cart is empty.');
    }

    const zohoUrl = buildZohoFormUrl(cart);

    console.log('Save Cart: Zoho form URL:', zohoUrl);

    iframe.addEventListener(
      'load',
      () => {
        console.log('Save Cart: Zoho iframe loaded.');
        loading.hidden = true;
        iframe.hidden = false;
      },
      { once: true }
    );

    iframe.addEventListener(
      'error',
      () => {
        console.error('Save Cart: Zoho iframe failed to load.');
        loading.hidden = true;
        iframe.hidden = true;
        error.hidden = false;
      },
      { once: true }
    );

    /*
     * Do not keep a lazy-loaded iframe hidden while waiting
     * for its load event.
     */
    iframe.hidden = false;
    iframe.src = zohoUrl;

    /*
     * Show an error rather than leaving the loading message
     * indefinitely.
     */
    window.setTimeout(() => {
      if (!loading.hidden) {
        console.error('Save Cart: iframe loading timed out.');
        loading.hidden = true;
        error.hidden = false;
      }
    }, 15000);
  } catch (err) {
    console.error('Save Cart error:', err);

    loading.hidden = true;
    iframe.hidden = true;
    error.hidden = false;

    error.textContent =
      err instanceof Error
        ? `We could not prepare your saved cart: ${err.message}`
        : 'We could not prepare your saved cart. Please try again.';
  }
}


function initialiseSaveCart() {
    document.addEventListener('click', async (event) => {
      const openButton = event.target.closest(selectors.open);
      if (openButton) {
        const root = openButton.closest(selectors.root);
        if (!root) return;
        openModal(root);
        await prepareForm(root);
        return;
      }

      const closeTrigger = event.target.closest(selectors.close);
      if (closeTrigger) {
        const root = closeTrigger.closest(selectors.root);
        if (root) closeModal(root);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(selectors.modal).forEach((modal) => {
        if (!modal.hidden) {
          const root = modal.closest(selectors.root);
          if (root) closeModal(root);
        }
      });
    });
  }

  initialiseSaveCart();
})();